import React from 'react';
import MainLayout from '../components/MainLayout';

export default function VisionAndMission() {
  return (
    <>
    <MainLayout>

    <div className='container'>

        <div className='row'>
        <div className='col-12'>
        VisionAndMission
        </div>
        </div>

    </div>

    </MainLayout>
    </>
  )
}
